var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-quility-rx-leaderboards',{attrs:{"show_filters":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }